const SearchFields = {
  QUERY: 'query',
  SORT: 'sort',
  TAGS: 'tags',
  FOOD_PREFERENCES: 'useFoodPreferences',
};

export default SearchFields;
